<template>
  <el-dialog title="提示" :visible.sync="visible" width="268px" :append-to-body="true" center>
    <div class="pop-tips">
      <div class="title">{{ title }}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button  type="primary" @click="visible = false">{{ buttonText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "popDelete",
  props: {
    title: {
      type: String,
      default: '删除'
    },
    buttonText: {
      type: String,
      default: '确定'
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  created() {
    
    
  },
  methods: {
    show() {
      this.visible = true
    },
  }
}
</script>

<style lang="scss" scoped>
.pop-tips{
  text-align: center;
  line-height: 1.5;
  .title{
    font-size: 14px;
    color: #2F3030;
  }
}
</style>
